<template>
  <div class="propress-wrapper">
    <div class="main">
      <div class="match-detail">
        <div class="name guard">{{isGuardMember ? '我方' : '敌方'}}</div>
        <div class="score guard">{{guardScore}}</div>
        <div class="progress-wrapper">
          <div
            :style="{ width: computedProgress }"
            class="progress progress-left"></div>
          <div class="progress progress-right"></div>
        </div>
        <div class="score offensive">{{offensiveScore}}</div>
        <div class="name offensive">{{isGuardMember ? '敌方' : '我方'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    guardScore: {
      type: Number,
      default: 0,
    },
    isGuardMember: {
      type: Boolean,
      default: false,
    },
    offensiveScore: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    computedProgress() {
      const progress = `${this.guardScore / (this.offensiveScore + this.guardScore) * 100}%`;
      return progress || '50%';
    },
  },
};
</script>

<style lang="scss" scoped>
  .propress-wrapper {
    position: fixed;
    top: 10px;
    left: calc(50% - 35vh);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80vh;
    height: 8vh;
    color: #fff;
    z-index: 9999;
    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/0ddc1ef719e693e3517b149c301ff89c.png')
      no-repeat center center / 100% 100%;
    .main {
      width: 88%;
      .match-detail {
        display: flex;
        align-items: center;
        .guard {
          color: #2843CF;
        }
        .offensive {
          color: #DE1919;
        }
        .name {
          width: 30px;
          text-align: center;
        }
        .score {
          min-width: 30px;
          text-align: center;
        }
        .progress-wrapper {
          flex: 1;
          display: flex;
          height: 10px;
          border-radius: 25px;
          overflow: hidden;
          animation: pulse 1.5s infinite linear;
          .progress {
            background-image: -webkit-linear-gradient(
                45deg,
                rgba(255, 255, 255, 0.2) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.2) 50%,
                rgba(255, 255, 255, 0.2) 75%,
                transparent 75%,
                transparent
            );
            transition: width 2s;
          }
          .progress-left {
            width: 50%;
            height: 100%;
            background-color: #0a69e3;
          }
          .progress-right {
            flex: 1;
            height: 100%;
            background-color: #ef2930;
          }
        }
      }
    }
  }
  @keyframes pulse {
    0% {
      box-shadow: 0px 0px 2px 0px rgba(64,158,255,.3);
    }
    65% {
      box-shadow: 0px 0px 2px 8px rgba(64,158,255,.3);
    }
    90% {
      box-shadow: 0px 0px 2px 8px rgba(64,158,255,0);
    }
  }
</style>
